//skill bar react component
function SkillBar(props) {

    return (
        <div className="skill-bar">
            <div className="skill-bar-name">{props.name}</div>
            <div className="skill-bar-description">{props.description}</div>
            <div className="skill-bar-fill" style={{ width: `${props.percent}%` }}></div>
        </div>
    );

}

export default SkillBar;